<div class="modal-header">
  <h4 class="modal-title pull-left">{{'MODALE_OPERATION.OPERATION' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form id="myForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label for="selectType">{{'MODALE_DONNEE_SUIVI.TYPE' |translate}}</label>
      <ng-select name="selectType"
        id="selectType"
        [items]="tabTypeOp"
        bindLabel="nom"
        [(ngModel)]="typeOpSelectionne"
        [addTag]="true">
      </ng-select>
      @if (typeNonValide) {
        <div class="custom-alert custom-alert-sm">{{'GLOBAL.CHAMP_OBLIGATOIRE' | translate}}</div>
      }
    </div>
    <div class="form-group">
      <label for="selectOperator">{{'GLOBAL.OPERATORS' |translate}}</label>
      <ng-select name="selectOperator"
        id="selectOperator"
        [items]="tabOperateurs"
        bindLabel="nom"
        [(ngModel)]="operateurSelectionne">
      </ng-select>
    </div>
    <div class="row">
      <div class="col-md-4 form-group">
        <label for="selectTimeDebut">{{'MODALE_OPERATION.HEURE_DEBUT' | translate}}</label>
        <timepicker id="selectTimeDebut" [ngModel]="dateDebut" (ngModelChange)="changeDebut($event)" [showMeridian]="false" name="selectTimeDebut"></timepicker>
      </div>
      <div class="col-md-4 form-group">
        <label for="selectDuree">{{'GLOBAL.DURATION' | translate}}</label>
        <timepicker id="selectDuree" [ngModel]="duree" (ngModelChange)="changeDuree($event)" [showMeridian]="false" name="selectDuree"></timepicker>
      </div>

      <div class="col-md-4 form-group">
        <label for="selectTimeFin">{{'MODALE_OPERATION.HEURE_FIN' | translate}}</label>
        <timepicker id="selectTimeFin" [ngModel]="dateFin" (ngModelChange)="changeFin($event)" [showMeridian]="false" name="selectTimeFin"></timepicker>
      </div>
    </div>
    <div class="form-group">
      <label for="selectEquipements">{{'MODALE_DONNEE_SUIVI.EQUIPEMENTS' | translate}}</label>
      <ng-select name="selectEquipements"
        id="selectEquipements"
        [items]="tabEquipements"
        bindLabel="nom"
        [(ngModel)]="equipementsSelectionnes"
        [addTag]="true"
        [hideSelected]="true"
        [multiple]="true"
        [closeOnSelect]="false">
      </ng-select>
    </div>
    @if (erreur) {
      <div class="custom-alert custom-alert-sm">{{'GLOBAL.MESSAGE_ERREUR' | translate}}</div>
    }

    <div class="btn-toolbar justify-content-between">
      <div class="btn-group" role="group">
        <button type="submit" class="btn btn-outline-success" style="margin-right:10px;">{{'GLOBAL.VALIDER' | translate}}</button>
        @if (estModif) {
          <button type="button" class="btn btn-danger" (click)="showModalSuppr()">{{'GLOBAL.SUPPRIMER' | translate}}</button>
        }
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
      </div>
    </div>
  </form>
</div>

<div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="delete()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideModalSuppr()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static', keyboard:false}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="annulModif()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="modalConfirmCancel.hide()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>
